import { DrawerOverlay } from '@chakra-ui/react'

export default DrawerOverlay
